<template>
  <div id="home" v-loading.fullscreen.lock="changeLoading">
    <!-- <Loading :loading="changeLoading" class="loading" /> -->
    <div style="background-color: white; margin: 1rem 2rem">
      <div class="pos_container_panel">
        <!--search area-->
        <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
          style="padding-top: 1rem"
          :label-width="LabelWidth"
        >
          <el-row style="">
            <el-col :span="8"
              ><div class="grid-content bg-purple">
                <el-form-item label="国家">
                  <el-select
                    default-first-option
                    filterable
                    v-model="searchForm.nation"
                    placeholder="国家"
                    style="width: 80%"
                    @change="selectNation"
                    clearable
                  >
                    <el-option
                      v-for="item in nationoption"
                      :key="item.countryCode"
                      :label="item.countryNameLists['zh-CN']"
                      :value="item.countryCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item></div
            ></el-col>
            <el-col :span="8"
              ><div class="grid-content bg-purple-light">
                <el-form-item label="州/省">
                  <el-select
                    default-first-option
                    filterable
                    clearable
                    @change="selectProvince"
                    v-model="searchForm.province"
                    placeholder="州/省"
                    style="width: 80%"
                  >
                    <el-option
                      v-for="item in provinceoption"
                      :key="item.provinceCode"
                      :label="item.provinceNameLists['zh-CN']"
                      :value="item.provinceCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item></div
            ></el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-form-item label="城市">
                  <el-select
                    default-first-option
                    filterable
                    @change="selectCity"
                    clearable
                    v-model="searchForm.city"
                    placeholder="城市"
                    style="width: 80%"
                  >
                    <el-option
                      v-for="item in cityoption"
                      :key="item.cityCode"
                      :label="item.cityNameLists['zh-CN']"
                      :value="item.cityCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item></div
            ></el-col>
          </el-row>
          <el-divider>使用上面或者下面进行数据查询</el-divider>
          <el-row>
            <el-col :span="4">
              <destination :parentCityCode="searchForm.cityCode" :returnParentValue="searchForm.cityName" @returnCityInfo="setDestination" :isHotCity="false"></destination>
            </el-col>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  @click="customSearch()"
                >
                  搜索</el-button
                >
                <el-button
                  type="warning"
                  class="harpIDbtn"
                  style="margin-left: 3rem"
                  @click="addCity()"
                >
                  新增
                </el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
        <!--table-->
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 50px"
        >
          <el-table-column
            prop="countryNameLists.zh-CN"
            label="国家名称-中文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="provinceNameLists.zh-CN"
            label="州/省名称-中文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cityCode"
            label="城市代码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cityNameLists.zh-CN"
            label="城市名称-中文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cityNameLists.en"
            label="城市名称-英文"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="tcCode"
            label="三字码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="longitude"
            label="高德-经度"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="latitude"
            label="高德-纬度"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="132" align="center">
          <template #default="scope">
            <el-button type="text" size="small" @click="bindMapping(scope.row)">关联映射</el-button>
            <el-button type="text" size="small" @click.prevent="deleteMapping(scope.row)">删除映射</el-button>
            <el-button type="text" size="small" @click="handleClick(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
            <el-button v-if="scope.row.enableFlag" type="text" size="small" @click.prevent="enable(scope.row)">启用</el-button>
            <el-button v-if="scope.row.disabledFlag" type="text" size="small" @click.prevent="disabled(scope.row)">禁用</el-button>
          </template>
        </el-table-column>
        </el-table>
        <div style="margin-bottom: 1rem">
          <el-pagination
            class="paginationsty"
            background
            @current-change="handleCurrentChange"
            v-model:current-page="currentPage1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="searchForm.total"
          >
          </el-pagination>
        </div>
        <!--新增 dialog-->
        <el-dialog title="新增城市" v-model="dialogFormVisible">
          <el-form :model="form" ref="checkInput">
            <el-form-item
              label="国家:"
              :label-width="formLabelWidth"
              prop="countryName"
              :rules="[
                {
                  required: true,
                  message: '请选择国家',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                default-first-option
                filterable
                @change="selectNationForm"
                style="width: 58%; margin-left: 85px"
                class="myselect_inner myicon_inner"
                v-model="form.countryName"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in nationoptionInit"
                  :key="item.value"
                  :label="item.countryName"
                  :value="item.countryCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="州/省:"
              :label-width="formLabelWidth"
              prop="province"
              :rules="[
                {
                  required: true,
                  message: '请选择州/省',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                default-first-option
                filterable
                @change="selectProvinceList"
                style="width: 58%; margin-left: 85px"
                class="myselect_inner myicon_inner"
                v-model="form.province"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in provinceForm"
                  :key="item.value"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="城市名称-中文:"
              :label-width="formLabelWidth"
              prop="cityCH"
              :rules="[
                {
                  required: true,
                  message: '请输入城市中文名称',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="form.cityCH"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="城市名称-英文:"
              :label-width="formLabelWidth"
              prop="cityEN"
              :rules="[
                {
                  required: true,
                  message: '请输入城市英文名称',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="form.cityEN"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="三字码:"
              :label-width="formLabelWidth"
              prop="tcCode"
            >
              <el-input
                v-model="form.tcCode"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="高德-经度:"
              :label-width="formLabelWidth"
              prop="longitude"
              :rules="[
                { required: true, message: '请输入高德-经度', trigger: 'blur' },
                {
                  pattern: /^[-]?\d+(\.\d+)?$/,
                  message: '请输入正确的高德-经度',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="form.longitude"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="高德-纬度:"
              :label-width="formLabelWidth"
              prop="latitude"
              :rules="[
                { required: true, message: '请输入高德-纬度', trigger: 'blur' },
                {
                  pattern: /^[-]?\d+(\.\d+)?$/,
                  message: '请输入正确的高德-经度',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="form.latitude"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="时区:"
              :label-width="formLabelWidth"
              prop="timeZone"
              :rules="[
                { required: true, message: '请选择时区', trigger: 'change' },
              ]"
            >
              <el-select
                default-first-option
                filterable
                v-model="form.timeZone"
                placeholder="请选择"
                style="width: 58%; margin-left: 85px"
                @change="selectTimeZone"
              >
                <el-option
                  v-for="item in timeZoneOption"
                  :key="item.key"
                  :label="item.timeZone"
                  :value="item.timeZone"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="多语言名称:" :label-width="formLabelWidth" prop="multiLanguages"
              :rules="[{ required: true, message: '请输入多语言名称', trigger: 'blur'}]">
              <el-input v-model="form.multiLanguages" autocomplete="off" type="textarea" style="width: 58%; margin-left: 85px"></el-input>
            </el-form-item>
          </el-form>
         <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="customAdd()">保存</el-button>
              <el-button @click="cancel()">取 消</el-button>
            </span>
          </template>
        </el-dialog>
        <!--修改 dialog-->
        <el-dialog title="修改城市" v-model="dialogChange">
          <el-form :model="changeForm" ref="checkInput">
            <el-form-item label="国家:" :label-width="formLabelWidth">
              <el-select
                style="width: 58%; margin-left: 85px"
                class="myselect_inner myicon_inner"
                v-model="changeForm.countryName"
                placeholder="请选择"
                disabled
              >
                <el-option
                  v-for="item in nationoption"
                  :key="item.value"
                  :label="item.countryNameLists['zh-CN']"
                  :value="item.countryNameLists['zh-CN']"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="州/省:" :label-width="formLabelWidth">
              <el-select
                disabled
                style="width: 58%; margin-left: 85px"
                class="myselect_inner myicon_inner"
                v-model="changeForm.provinceName"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in provinceoption"
                  :key="item.value"
                  :label="item.provinceNameLists['zh-CN']"
                  :value="item.provinceNameLists['zh-CN']"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="城市名称-中文:"
              :label-width="formLabelWidth"
              prop="cityCH"
              :rules="[
                {
                  required: true,
                  message: '请输入城市中文名称',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="changeForm.cityCH"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="城市名称-英文:"
              :label-width="formLabelWidth"
              prop="cityEN"
              :rules="[
                {
                  required: true,
                  message: '请输入城市英文名称',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="changeForm.cityEN"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="三字码:"
              :label-width="formLabelWidth"
              prop="tcCode"
            >
              <el-input
                v-model="changeForm.tcCode"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="高德-经度:"
              :label-width="formLabelWidth"
              prop="longitude"
              :rules="[
                { required: true, message: '请输入高德-经度', trigger: 'blur' },
                {
                  pattern: /^[-]?\d+(\.\d+)?$/,
                  message: '请输入正确的高德-经度',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="changeForm.longitude"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="高德-纬度:"
              :label-width="formLabelWidth"
              prop="latitude"
              :rules="[
                { required: true, message: '请输入高德-经度', trigger: 'blur' },
                {
                  pattern: /^[-]?\d+(\.\d+)?$/,
                  message: '请输入正确的高德-纬度',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="changeForm.latitude"
                autocomplete="off"
                style="width: 58%; margin-left: 85px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="时区:"
              :label-width="formLabelWidth"
              prop="timeZone"
              :rules="[
                { required: true, message: '请选择时区码', trigger: 'change' },
              ]"
            >
              <el-select
                v-model="changeForm.timeZone"
                placeholder="请选择"
                style="width: 58%; margin-left: 85px"
                @change="selectTimeZone"
              >
                <el-option
                  v-for="item in timeZoneOption"
                  :key="item.key"
                  :label="item.timeZone"
                  :value="item.timeZone"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="多语言名称:" :label-width="formLabelWidth" prop="multiLanguages"
              :rules="[{ required: true, message: '请输入多语言名称', trigger: 'blur'}]">
              <el-input v-model="changeForm.multiLanguages" autocomplete="off" type="textarea" style="width: 58%; margin-left: 85px"></el-input>
            </el-form-item>
          </el-form>
         <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="changeSave()">保存</el-button>
              <el-button @click="cancel()">取 消</el-button>
            </span>
          </template>
        </el-dialog>
      </div>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <el-dialog
      title="警告"
      v-model="dialogVisible"
      width="30%"
     
    >
      <span>{{ this.delMappingMsg !== "" ? this.delMappingMsg : "将删除该城市所有信息，请确认是否删除" }}</span>
     <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--关联映射-->
    <el-dialog title="关联映射" v-model="bindMappingFlag">
      <el-form :model="bindMappingForm" ref="bindMappingInput">
        <el-form-item label="GEO编码:" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="bindMappingForm.GEOCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item label="第三方系统:" :label-width="formLabelWidth">
          <el-select
            style="width: 58%; margin-left: 85px"
            class="myselect_inner myicon_inner"
            v-model="bindMappingForm.remoteSystemCode"
            placeholder="请选择"
          >
            <el-option
              v-for="item in remoteSystemList"
              :key="item.code"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="第三方系统编码:"
          :label-width="formLabelWidth"
          prop="remoteSystemMappingCode"
          :rules="[
            {
              required: true,
              message: '请输入第三方系统编码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            required
            v-model="bindMappingForm.remoteSystemMappingCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="saveMapping()">保存</el-button>
        <el-button @click="cancel('bindMappingFlag')">取 消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  cityconfigList,
  getcountryList,
  getprovinceList,
  savecityList,
  deletecityList,
  buttonEnable,
  fetchMapping,
  deleteMapping,
  saveMapping,
} from "@/api/shoppingData";
import Destination from "../../components/Destination.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
export default {
  name: "HBELocations",
  components: {
    ConfirmBoxs,
    Destination
  },
  data() {
    return {
      destinationType: "",
      destinationTypeChanged: "",
      selectCountryCode: "",
      dialogVisible: false,
      changeLoading: false,
      changeRow: "",
      clickRow: {},
      deleteparams: "",
      deleteFlag: false,
      frequentlyUsedFlag: "",
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      dialogFormVisible: false,
      dialogChange: false,
      timeZoneOption: [
        {
          key: 1,
          timeZone: "UTC",
        },
        {
          key: 2,
          timeZone: "UTC+1",
        },
        {
          key: 3,
          timeZone: "UTC+2",
        },
        {
          key: 4,
          timeZone: "UTC+3",
        },
        {
          key: 5,
          timeZone: "UTC+4",
        },
        {
          key: 6,
          timeZone: "UTC+5",
        },
        {
          key: 7,
          timeZone: "UTC+6",
        },
        {
          key: 8,
          timeZone: "UTC+7",
        },
        {
          key: 9,
          timeZone: "UTC+8",
        },
        {
          key: 10,
          timeZone: "UTC+9",
        },
        {
          key: 11,
          timeZone: "UTC+10",
        },
        {
          key: 12,
          timeZone: "UTC+11",
        },
        {
          key: 13,
          timeZone: "UTC+12",
        },
        {
          key: 14,
          timeZone: "UTC-11",
        },
        {
          key: 15,
          timeZone: "UTC-10",
        },
        {
          key: 16,
          timeZone: "UTC-9",
        },
        {
          key: 17,
          timeZone: "UTC-8",
        },
        {
          key: 18,
          timeZone: "UTC-7",
        },
        {
          key: 19,
          timeZone: "UTC-6",
        },
        {
          key: 20,
          timeZone: "UTC-5",
        },
        {
          key: 21,
          timeZone: "UTC-4",
        },
        {
          key: 22,
          timeZone: "UTC-3",
        },
        {
          key: 23,
          timeZone: "UTC-2",
        },
        {
          key: 24,
          timeZone: "UTC-1",
        },
      ],
      form: {
        province: "",
        countryCode: "",
        countryName: "",
        provinceName: "",
        cityCH: "",
        cityEN: "",
        tcCode: "",
        latitude: "",
        longitude: "",
        timeZone: "",
        countryId: "",
        provinceId: "",
        provinceCode: "",
        geoCodeType: "",
        multiLanguages:"",
      },
      changeForm: {
        countryCode: "",
        countryName: "",
        provinceName: "",
        cityCH: "",
        cityEN: "",
        tcCode: "",
        latitude: "",
        longitude: "",
        timeZone: "",
        countryId: "",
        provinceId: "",
        provinceCode: "",
        geoCodeType: "",
        id:"",
        multiLanguages:"",
        frequentlyUsedFlag:"",
      },
      //
      LabelWidth: "5rem",
      currentPage1: 1,
      formLabelWidth: "15rem",
      selecttype: 0,
      selectnation: "",
      selectprovince: "",
      selectcity: "",
      locationCode: "",
      paramsCitycode: "",
      tableData: [],
      searchForm: {
        total: null,
        nation: "",
        province: "",
        city: "",
        nameEN: "", //位置名称
        cityCode: "",
        cityName: "",
      },
      cityoption: [],
      nationoption: [],
      nationoptionForm: [],
      provinceoption: [],
      nationoptionInit: [],
      provinceForm: [],
      bindMappingFlag: false,
      remoteSystemList: [
        {
          code: "FX",
          value: "FX",
        },
      ],
      bindMappingForm: {
        GEOCode: "",
        remoteSystemCode: "FX",
        remoteSystemMappingCode: "",
      },
      delMappingMsg: "",
    };
  },
  mounted() {
    this.getCountryList();
  },
  methods: {
    enable(data) {
      let getParams = {
        params: {
          type: 2,
          code: data.cityCode,
          action: 1,
        },
      };
      console.log(getParams, "getParams");
      this.getBtnDisplay(getParams);
    },
    disabled(data) {
      let getParams = {
        params: {
          type: 2,
          code: data.cityCode,
          action: 0,
        },
      };
      console.log(getParams, "getParams");
      this.getBtnDisplay(getParams);
    },
    async getBtnDisplay(getParams) {
      this.changeLoading = true;
      console.log(getParams, "传参");
      await buttonEnable(getParams).then((res) => {
        if (res.code === 200) {
          this.changeLoading = false;
          this.customSearch();
          console.log(res, "res====>");
        }
      });
    },
    //国省市change事件
    selectNation(value) {
      this.selectCountryCode = value;
      this.searchForm.province = "";
      this.searchForm.city = "";
      this.selectcity = "";
      this.selectprovince = "";
      this.cityoption = [];
      this.provinceoption = [];
      this.selectnation = value;
      if (value) {
        this.getProvinceList(value);
        this.getCityList();
      }
    },

    selectProvince(value) {
      this.searchForm.city = "";
      this.selectcity = "";
      this.cityoption = [];
      this.selectprovince = value;
      this.provinceCode = this.selectprovince;
      if (value) {
        this.getCityList(value);
      }
    },

    selectCity(value) {
      this.selectcity = value;
      this.cityCode = this.selectcity;
    },
    //新增from国change事件
    selectNationForm(value) {
      this.getProvinceListForm(value);

      this.getCountryListCode(value);
      this.form.countryCode = value;
      this.form.province = "";
    },
    selectProvinceList(value) {
      this.getProvinceParams(value);
      this.getCityListCode(value);
    },
    selectTimeZone(value) {
      console.log(value, "1111");
    },
    //获取搜索下拉值-国省市
    async getCountryList() {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.nationoption = res.data.list;
            console.log("获取国家下拉值", res.data.list);
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          console.log("获取国家下拉值 请求失败", error.objError);
        });
    },
    // 获取弹出框 国家code
    async getCountryListCode(value) {
      console.log("新增下拉");
      let searchparams = {
        params: {
          countryCode: value,
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          this.nationoptionForm = res.data.list;
          this.nationoptionForm.map((item) => {
            this.form.countryId = item.countryId;
            if (item.countryCode === "100000") {
              this.destinationType = "D";
            } else {
              this.destinationType = "I";
            }
          });
          console.log("获取国家下拉值", res.data.list);
        })
        .catch(function (error) {
          console.log("获取国家下拉值 请求失败", error.objError);
        });
    },
    // 新增form下拉框选中事件
    async getProvinceListForm(value) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: value,
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.provinceForm = res.data.list;
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("国家下拉值 请求失败", error.objError);
        });
    },
    async getProvinceList(value) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: value, //this.selectnation
          provinceCode: "", //?
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.provinceoption = res.data.list;
            this.provinceoption.map((item) => {
              this.changeForm.provinceId = item.provinceId;
            });
          } else {
            this.changeLoading = false;
          }
          console.log("获取省下拉值", res.data.list);
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("省下拉值 请求失败", error.objError);
        });
    },
    // 获取省份ID 的操作
    async getProvinceParams(value) {
      let searchparams = {
        params: {
          countryCode: this.form.countryCode,
          provinceCode: value,
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          res.data.list.map((item) => {
            this.form.provinceId = item.provinceId;
            return item;
          });
        })
        .catch(function (error) {
          console.log("国家下拉值 请求失败", error.objError);
        });
    },
    async getCityList(value) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: this.selectCountryCode,
          provinceCode: value,
          cityCode: "", //?
        },
      };
      await cityconfigList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.cityoption = res.data.list;
          } else {
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("城市下拉值 请求失败", error.objError);
        });
    },
    async getCityListCode(value) {
      let searchparams = {
        params: {
          countryCode: this.form.countryCode,
          provinceCode: value,
          cityCode: "", //?
        },
      };
      await getprovinceList(searchparams)
        .then((res) => {
          res.data.list.map((item) => {
            // this.form.geoCodeType = item.geoCodeType;
            this.form.provinceCode = item.provinceCode;
            return item;
          });
        })
        .catch(function (error) {
          console.log("城市下拉值 请求失败", error.objError);
        });
    },
    // 新增form下拉框选中事件
    async getCountryListInit() {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: "",
        },
      };
      await getcountryList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.nationoptionInit = res.data.list;
            console.log("获取国家下拉值", res.data.list);
          }
        })
        .catch(function (error) {
          console.log("国家下拉值 请求失败", error.objError);
        });
    },
    // 新增button
    addCity() {
      this.getCountryListInit();
      this.dialogFormVisible = true;
    },
    //新增保存
    async customAdd() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            aliasName: "",
            destinationType: this.destinationType,
            tcCode: this.form.tcCode,
            cityName: this.form.cityCH,
            countryId: this.form.countryId,
            countryCode: this.form.countryCode,
            provinceId: this.form.provinceId,
            provinceCode: this.form.provinceCode,
            frequentlyUsedFlag: 0,
            latitude: this.form.latitude,
            longitude: this.form.longitude,
            geoCodeType: this.form.geoCodeType,
            timeZone: this.form.timeZone,
            multiLanguages: this.form.multiLanguages,
            cityNames: [
              {
                languageCode: "zh-CN",
                name: this.form.cityCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.form.cityEN,
                description: "",
              },
            ],
          };
          console.log(saveParams, "saveParams");
          this.saveNew(saveParams);
          this.dialogFormVisible = false;
        }
      });
    },
    async saveNew(saveParams) {
      await savecityList(saveParams)
        .then((res) => {
          if (res.code === 200) {
            this.$refs.checkInput.resetFields();
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "新增成功";
            this.deleteFlag = false;
            this.getCityList(this.selectprovince);
            this.customSearch();
          } else {
            this.$refs.checkInput.resetFields();
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "新增失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          // this.$refs.checkInput.resetFields();
          console.log("新增失败", error.objError);
          this.deleteFlag = false;
          this.customSearch();
        });
    },
    // 保存关联映射
    saveMapping() {
      this.$refs["bindMappingInput"].validate(async (valid) => {
        if (valid) {
          console.log(this.bindMappingForm);
          this.bindMappingFlag = false;
          this.changeLoading = true;
          const bindMappingForm = this.bindMappingForm;
          const saveMappingRequests = {
            type: "citymapping",
            data: {
              cityCode: bindMappingForm.cityCode,
              cityId: bindMappingForm.cityId ? bindMappingForm.cityId : "",
              remoteSystemCode: bindMappingForm.remoteSystemCode,
              remoteSystemCityCode: bindMappingForm.remoteSystemMappingCode,
              userName: this.$objBaseInfo.loginID,
            },
          };
          console.log(saveMappingRequests);
          let confirmMsg = "";
          await saveMapping(saveMappingRequests)
            .then(async (res) => {
              console.log(res);
              if (res.code === 200) {
                if (res.data.status === 1) {
                  confirmMsg = "已成功关联映射";
                } else {
                  confirmMsg = "关联映射失败，请重新操作";
                }
              } else {
                confirmMsg = res.data.error.message;
              }
            })
            .catch(function (error) {
              console.log("修改失败", error.objError);
            });
          if (confirmMsg !== "") {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = confirmMsg;
          }
        }
      });
    },
    // 关联映射
    async bindMapping(row) {
      console.log(row);
      const fetchMappingRequests = {
        type: "citymapping",
        paramsObj: {
          params: {
            cityCode: row.cityCode,
            remoteSystemCode: "FX",
          },
        },
      };
      var fetchMappingData = await fetchMapping(fetchMappingRequests);
      console.log(fetchMappingData);
      this.bindMappingFlag = true;
      let bindMappingForm = this.bindMappingForm;
      bindMappingForm.GEOCode = row.cityCode;
      bindMappingForm.remoteSystemMappingCode =
        fetchMappingData.data.length > 0
          ? fetchMappingData.data[0].remoteSystemCityCode
          : "";
      this.bindMappingForm = {
        ...bindMappingForm,
        ...fetchMappingData,
        ...row,
      };
    },
    // 删除映射
    async deleteMapping(row) {
      console.log(row);
      const that = this;
      const fetchMappingRequests = {
        type: "citymapping",
        paramsObj: {
          params: {
            cityCode: row.cityCode,
            remoteSystemCode: "FX",
          },
        },
      };
      console.log(fetchMappingRequests);
      let confirmMsg = "";
      await fetchMapping(fetchMappingRequests)
        .then(async (res) => {
          console.log(res);
          if (res.code === 200) {
            if (res.data.length > 0) {
              that.dialogVisible = true;
              that.delMappingMsg = "您将删除当前城市的关联映射，是否继续？";
              let resData = { ...res.data[0], ...row };
              that.clickRow = resData;
            } else {
              confirmMsg = "暂未查询到该国家的映射数据";
            }
          } else {
            confirmMsg = "查询映射失败，请重新操作";
          }
        })
        .catch(function (error) {
          console.log("修改失败", error.objError);
        });
      if (confirmMsg !== "") {
        this.confirmMsg = confirmMsg;
        this.confirmFlag = true;
      }
    },
    async confirmDelMapping() {
      console.log(this.clickRow);
      let confirmMsg = "";
      const deleteMappingRequests = {
        type: "citymapping",
        paramsObj: {
          params: {
            cityCode: this.clickRow.cityCode,
            userName: this.$objBaseInfo.loginID,
            remoteSystemCityCode: this.clickRow.remoteSystemCityCode,
            remoteSystemCode: this.clickRow.remoteSystemCode,
          },
        },
      };
      await deleteMapping(deleteMappingRequests)
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            if (!res.status) {
              confirmMsg = "删除映射失败";
            } else {
              confirmMsg = "映射已删除";
            }
          } else {
            confirmMsg = "删除映射失败";
          }
        })
        .catch(function (error) {
          this.delMappingMsg = "";
          console.log("删除映射失败", error.objError);
        });
      if (confirmMsg !== "") {
        this.delMappingMsg = "";
        this.confirmMsg = confirmMsg;
        this.confirmFlag = true;
      }
    },
    //修改button
    handleClick(row) {
      this.changeRow = row;
      this.dialogChange = true;
      (this.changeForm.countryName = this.changeRow.countryNameLists["zh-CN"]),
        (this.changeForm.provinceName =
          this.changeRow.provinceNameLists["zh-CN"]),
        (this.changeForm.cityCH = this.changeRow.cityNameLists["zh-CN"]),
        (this.changeForm.cityEN = this.changeRow.cityNameLists["en"]),
        (this.changeForm.tcCode = this.changeRow.tcCode),
        (this.changeForm.latitude = this.changeRow.latitude),
        (this.changeForm.longitude = this.changeRow.longitude);
      this.changeForm.timeZone = this.changeRow.timeZone;
      this.changeForm.geoCodeType = this.changeRow.geoCodeType;
      this.changeForm.cityCode = this.changeRow.cityCode;
      this.changeForm.provinceCode = this.changeRow.provinceCode;
      this.changeForm.countryCode = this.changeRow.countryCode;
      this.changeForm.provinceId = this.changeRow.provinceId;
      this.changeForm.countryId = this.changeRow.countryId;
      this.changeForm.id = this.changeRow.cityId;
      this.changeForm.multiLanguages = this.changeRow.multiLanguages;
      this,this.changeForm.frequentlyUsedFlag = this.changeRow.frequentlyUsedFlag;
      if (this.changeForm.countryCode === "100000") {
        this.destinationTypeChanged = "D";
      } else {
        this.destinationTypeChanged = "I";
      }
    },
    //修改保存
    async changeSave() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            destinationType: this.destinationTypeChanged,
            cityCode: this.changeForm.cityCode,
            tcCode: this.changeForm.tcCode,
            cityName: this.changeForm.cityCH,
            countryId: this.changeForm.countryId,
            countryCode: this.changeForm.countryCode,
            provinceId: this.changeForm.provinceId,
            provinceCode: this.changeForm.provinceCode,
            frequentlyUsedFlag: this.changeRow.frequentlyUsedFlag,
            latitude: this.changeForm.latitude,
            longitude: this.changeForm.longitude,
            geoCodeType: this.changeForm.geoCodeType,
            timeZone: this.changeForm.timeZone,
            id: this.changeForm.id,
            multiLanguages: this.changeForm.multiLanguages,
            cityNames: [
              {
                languageCode: "zh-CN",
                name: this.changeForm.cityCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.changeForm.cityEN,
                description: "",
              },
            ],
          };
          console.log(saveParams, "saveParams");
          this.saveChange(saveParams);
          this.dialogChange = false;
        }
      });
    },
    async saveChange(saveParams) {
      await savecityList(saveParams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "操作成功";
            this.deleteFlag = false;
            this.getCityList(this.selectprovince);
            this.customSearch();
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "操作失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          console.log("保存失败", error.objError);
          this.deleteFlag = false;
          this.customSearch();
        });
    },
    //取消button
    cancel(type) {
      if (type === "bindMappingFlag") {
        this.$refs.bindMappingInput.clearValidate();
        this.bindMappingFlag = false;
        this.delMappingMsg = "";
        this.bindMappingForm.remoteSystemMappingCode = "";
      } else {
        this.$refs.checkInput.resetFields();
        this.dialogChange = false;
        this.dialogFormVisible = false;
      }
    },
    //删除
    async deleteRow(row) {
      this.dialogVisible = true;
      this.deleteparams = {
        params: {
          cityCode: row.cityCode,
        },
      };
    },
    cancelDelete() {
      this.dialogVisible = false;
    },
    confirmDelete() {
      this.dialogVisible = false;
      if (this.delMappingMsg !== "") {
        this.confirmDelMapping();
        return false;
      }
      deletecityList(this.deleteparams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.deleteFlag = false;
            this.customSearch();
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
            this.deleteFlag = false;
            this.customSearch();
          }
        })
        .catch(() => {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "删除失败";
          this.deleteFlag = false;
          this.customSearch();
        });
    },
    //搜索button
    async customSearch(int) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          countryCode: this.selectnation,
          provinceCode: this.selectprovince,
          cityCode: this.selectcity,
          page: int ? int : 1,
          per_page: 10,
        },
      };
      await cityconfigList(searchparams)
        .then((res) => {
          if (res.code === 200) {
            res.data.list.map((item) => {
              if (item.isEnable === 1) {
                item.enableFlag = false;
                item.disabledFlag = true;
              } else if (item.isEnable === 0) {
                item.enableFlag = true;
                item.disabledFlag = false;
              }
              return item;
            });
            this.currentPage1 = res.data.pageNumber;
            this.changeLoading = false;
            this.tableData = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "搜索城市信息失败，请稍后重试";
            this.deleteFlag = false;
          }
        })
        .catch(function (error) {
          console.log("城市信息 请求失败", error.objError);
        });
    },
    //分页
    handleCurrentChange(val) {
      this.customSearch(val);
      console.log(`当前页: ${val}`);
    },
    setConfirmFlag(value) {
      this.changeLoading = false;
      this.confirmFlag = value;
    },
    setDestination(value) {
      if(value.cityCode  != ''){
        this.selectnation = value.cityInfo.countryCode;
        this.selectprovince = value.cityInfo.provinceCode;
        this.selectcity = value.cityCode;
      }
    }
  },
};
</script>

<style scoped>
.loading {
  z-index: 99999999;
}
::v-deep .el-table__header {
  width: 100%;
}
.pos_container_panel {
  padding: 0px 8rem 4rem;
  overflow-x: hidden;
}
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
